import { render, staticRenderFns } from "./HiddenHeaderLayout.vue?vue&type=template&id=35a172a0&"
import script from "./HiddenHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./HiddenHeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./HiddenHeaderLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports